import { render, staticRenderFns } from "./AdditionalVisitorSafeguardingForm.vue?vue&type=template&id=651d9c6c&"
import script from "./AdditionalVisitorSafeguardingForm.vue?vue&type=script&lang=js&"
export * from "./AdditionalVisitorSafeguardingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports